import type { Accessory } from '@/features/basket/types/accessory';
import type { Product } from '@/features/basket/types/product';
import { GA4Event } from '@/libs/ga4';
import { sendEvent } from '@/libs/ga4/functions/send-event';
import { mapper } from '@/libs/ga4/maps/map-products';

export function ga4_addToCart(product: Product | Accessory, quantity?: number) {
  sendEvent(GA4Event.AddToCart, {
    items: [mapper(product, 1, undefined, quantity)],
  });
}
